import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "../../modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";


@Component({
  selector: 'app-garant-base-info',
  templateUrl: './garant-base-info.component.html',
  styleUrls: ['./garant-base-info.component.scss']
})
export class GarantBaseInfoComponent implements OnInit {

  busyGet: Subscription;
  filiale_id: any;
  user: any = {};
  currentData: any;
  modalRef:BsModalRef
  @Input() dataGarant:any
  @Output() onGetGarantInfo= new EventEmitter<any>();

  itemGarant: any = {};
  itemsFiliale: any;

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService:BsModalService
  ) {
    this.user = this.authService.getCurrentUser();
    this.filiale_id = this.user.filiale_id;
    console.log("this.currentData: ", this.currentData);
    // setTimeout(() => {
    //   if (this.currentData) {
    //     this.getItemGarant(this.currentData.id);
    //   }
    // }, 50);

    
  }

 
  ngOnChanges(changes: SimpleChanges) {
    console.log('changes: ',changes)

    if (changes.dataGarant.currentValue) {
      setTimeout(() => {
        
        // this.getItemsSecteurUser(changes.userId.currentValue)
        let garant = changes.dataGarant.currentValue
        this.getItemGarant(garant.id)
        
          });
    }
    
  }
  
  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => {}
      );
  }

  getItemGarant(garant_id) {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        id: garant_id,
      },
    };

    this.busyGet = this.restClient
      .post("garant/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemGarant = res["items"][0];
            console.log("data to emit: ",this.itemGarant)
            this.onGetGarantInfo.emit(this.itemGarant)
          } else {
            this.itemGarant = {};
            this.onGetGarantInfo.emit({})

          }
        },
        (err) => {
          this.itemGarant = {};
        }
      );
  }

  handleImageError(item) {
    item.image_url = "assets/images/custom/user-ano.jpeg";
  }

  openModalReseau() {
    if(!this.itemGarant.reseau_de_soin_id)
      return
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 54581554500,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
 
    let data = {reseau_de_soin_id:this.itemGarant.reseau_de_soin_id,reseau_de_soin_libelle:this.itemGarant.reseau_de_soin_libelle}
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
    });
  
  
  }

  ngOnInit() {
    this.getItemsFiliale();
  }

}
